<template>
  <div class="page flex-col">
    <div class="section_2 flex-col">
      <div class="group_1 flex-row">
        <span class="text_7" style="cursor: pointer" @click="handleJump('/home')">首页</span>
        <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_8" style="cursor: pointer" @click="handleClick(0, true)">加入我们</span>
        <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_9" style="cursor: pointer" @click="handleClick(0)">企业现状</span>
        <img
            class="thumbnail_3"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_10">产品与服务</span>
      </div>
      <div class="title_1">经营服务范围涉及校园食堂餐饮、校园超市、校园商业、校园物业、校园配套、校园外卖、资产投资管理等全后勤综合设施管理（FM）与服务。</div>
      <div class="group_2 flex-row justify-between">
        <div class="image-text_1 flex-col justify-between">
          <div class="text-wrapper_1 flex-col"></div>
          <span class="text-group_1">
              配置专业的困师团队或管理团队，满足自营、租货、抑点等多种好营方式需求。
              <br />
            </span>
        </div>
        <div class="image-text_2 flex-col justify-between">
          <div class="text-wrapper_2 flex-col"></div>
          <span class="text-group_2">
              堅合优势供应链，指盖货品、百货、日化、教育等相关产品，两足在校师生购物罚求。
              <br />
            </span>
        </div>
        <div class="image-text_3 flex-col justify-between">
          <div class="text-wrapper_3 flex-col"></div>
          <span class="text-group_3">
              公司专业管理人才队伍，构强校园商业体怀准体系，现沱业态慈譬风气，杜绝惡意竞争。
              <br />
            </span>
        </div>
        <div class="box_3 flex-col justify-between">
          <div class="text-wrapper_6 flex-col"></div>
          <span class="paragraph_1">
              对接校园供应链系烧，优化资源、整合业态布局，制定行业经画规范，提高校园经济活跃堡、满意盘。
              <br />
            </span>
        </div>
      </div>
      <div class="group_3 flex-row justify-start">
        <div class="image-text_4 flex-col justify-between">
          <div class="text-wrapper_4 flex-col"></div>
          <span class="text-group_4">
              照决校园外卖的最后一公里。独家合作校园外卖品牌“橙子校园”，满足师生线上购物需求，同时为学生提供勒工俭学的平台。
              <br />
            </span>
        </div>
        <div class="image-text_5 flex-col justify-between">
          <div class="text-wrapper_5 flex-col"></div>
          <span class="text-group_5">
              以需求为导向，提供校园经济解决方累。供给自贩机、沅衣系统、热水系统、饮水系统、物流系统、智慧按园等服务，满足学生多元化需求。
            </span>
        </div>
      </div>
      <div class="image-text_6 flex-row justify-between" style="cursor: pointer" @click="handleClick(0)">
        <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./../../assets/img/return.webp"
        />
        <span class="text-group_6">返回</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    handleJump(url, data = {}) {
      if (url === this.$route.path) return;
      this.$router.push({
        path: url,
        query: data
      });
      window.scrollTo(0,0);
    },
    handleClick(value, top = false) {
      this.$emit('select', value, top);
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
